/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { isMobile } from 'react-device-detect'
import ItemShop from '@views/ItemShop'
//img
import ShopImg from '@assets/images/bg/shop.png'
// css
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { ChargingCompleteWrap } from './index.style'

const ChargingCompletePopup: React.FC = () => {
  const { globalStore, routerStore, logStore } = useRootStore()
  const { visibleChargingComplete } = globalStore

  const onCloseModal = async () => {
    globalStore.setVisibleChargingComplete(false)
  }

  const onClickShopHandler = () => {
    if (isMobile) {
      routerStore.push('/itemshop')
    } else {
      globalStore.addGeneralPopupProperties(<ItemShop/>, '상점', {
        wrapClassName: '', className: 'itemshop', isScroll: true, custom: false, clsBtn: false,
        closeCallback: () => {
          logStore.writeButtonLog({ pageId: 'd020', buttonId: '001' }).catch(console.error)
        }
      })
      globalStore.setVisibleSideBar(false)
    }
    onCloseModal()
  }

  return (
    <Modal
      transparent
      visible={visibleChargingComplete}
      maskClosable={false}
      onClose={onCloseModal}
      className="event"
    >
      <ChargingCompleteWrap onClick={onClickShopHandler}>
        <div className="txt-wrap">
          <span className="point-color--orange--modal txt-01">S캐시 충전완료!</span>
          <p className="txt-02">
            상점에서 G머니 구매 후
            <br/>
            베팅할 수 있습니다.
          </p>
        </div>
        <img src={ShopImg} alt="상점" style={{ width: '135px', height: '164px' }}/>
        <Button className="go-shop-btn">
          상점으로 이동
        </Button>
      </ChargingCompleteWrap>
      <ModalBg/>
    </Modal>
  )
}

export default observer(ChargingCompletePopup)

